var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 10.4001H53.6C54.2365 10.4001 54.847 10.653 55.2971 11.103C55.7471 11.5531 56 12.1636 56 12.8001V51.2001C56 51.8366 55.7471 52.4471 55.2971 52.8972C54.847 53.3472 54.2365 53.6001 53.6 53.6001H10.4C9.76348 53.6001 9.15303 53.3472 8.70294 52.8972C8.25286 52.4471 8 51.8366 8 51.2001V12.8001C8 12.1636 8.25286 11.5531 8.70294 11.103C9.15303 10.653 9.76348 10.4001 10.4 10.4001H20V5.6001H24.8V10.4001H39.2V5.6001H44V10.4001ZM39.2 15.2001H24.8V20.0001H20V15.2001H12.8V24.8001H51.2V15.2001H44V20.0001H39.2V15.2001ZM51.2 29.6001H12.8V48.8001H51.2V29.6001ZM17.6 36.8001H22.4V41.6001H17.6V36.8001ZM27.2 36.8001H46.4V41.6001H27.2V36.8001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.f835c8cdf34fbd1dde4a938596cca914.svg";
export { ForwardRef as ReactComponent };